<template>
  <div class="campaigns">
    <div class="inner-content">
      <p>Моля въведете електронната си поща, за да Ви изпратим линк за нова парола.</p>

      <v-form @submit.prevent="submitForm" class="form">
        <v-text-field
          filled
          name="email"
          label="Електронна поща"
          type="text"
          v-validate="'required|email'"
          v-model="email"
          :error-messages="errors.collect('email')"
          @keyup.enter="submitForm"
        ></v-text-field>

        <v-row>
          <v-col>
            <v-btn color="primary" @click="submitForm" :disabled="submitDisabled" :loading="loading">
              Изпрати <v-icon class="ml-3">send</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgottenPassword',

  data () {
    return {
      email: ''
    }
  },

  watch: {
    email (newValue) {
      this.email = newValue.replace(/ /g, '')
    }
  },

  methods: {
    submitForm () {
      if (this.submitDisabled) {
        return
      }

      this.$store.commit('setLoading', true)

      this.$store.dispatch('resetPassword', this.email).then(() => {
        this.$store.commit('setLoading', false)
        this.$store.commit('showAlert', { type: 'success', message: 'Изпратихме Ви имейл за създаване на нова парола.' })
        this.$router.push({ name: 'login' })
      }).catch(() => {
        this.email = ''
        this.$store.commit('setLoading', false)
        this.$store.commit('showError', 'Грешна или несъществуваща електронна поща.')
      })
    }
  },

  computed: {
    submitDisabled () {
      return this.loading || this.email.length === 0 || this.errors.items.length > 0 || this.loading
    },

    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>
